/*
  Arabic only: keeps the visible "selected value" text (e.g. "اللون: أسود") in Arabic after a swatch click.
  Reads the value maps printed by snippets/ar-option-sync.liquid (<script type="application/json" data-ar-opt-map>),
  so it also works inside quick view. Only changes visible text, never input values or data attributes.
  Loaded from snippets/scripts-tag.liquid on the Arabic locale only.
*/
(function () {
  if (window.__arOptSyncReady) return;
  window.__arOptSyncReady = true;

  var SELECTOR = '.option_value, .swatch-selected-value';
  var map = Object.create(null);
  var loadedMaps = new WeakSet();
  var watched = new WeakSet();
  var decoder = document.createElement('textarea');

  function decode(s) {
    decoder.innerHTML = s;
    return decoder.value;
  }

  function loadMaps() {
    document.querySelectorAll('script[data-ar-opt-map]').forEach(function (el) {
      if (loadedMaps.has(el)) return;
      loadedMaps.add(el);
      try {
        var data = JSON.parse(el.textContent);
        Object.keys(data).forEach(function (k) {
          if (data[k]) map[k] = decode(data[k]);
        });
      } catch (e) {}
    });
  }

  function fix(el) {
    var raw = (el.textContent || '').trim();
    var ar = raw && map[raw];
    if (ar && ar !== raw) el.textContent = ar;
  }

  // Watches only the selected-value labels themselves, not the whole page.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      if (el) el = el.closest(SELECTOR);
      if (el) fix(el);
    });
  });

  function scan() {
    loadMaps();
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      fix(el);
      if (!watched.has(el)) {
        watched.add(el);
        observer.observe(el, { childList: true, characterData: true, subtree: true });
      }
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  // New pickers (quick view, re-rendered sections) appear after a click, so re-scan then.
  ['change', 'click'].forEach(function (type) {
    document.addEventListener(
      type,
      function () {
        schedule();
        setTimeout(scan, 500);
      },
      true
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
